import VideoPlayer from "@components/VideoPlayer"
import { onMount } from "solid-js"
import { useService } from "solid-services"
import { useLessonState } from "./state"

export default function () {
  const { lessonQuery, setRequirementsMet } = useService(useLessonState)()

  onMount(() => {
    setRequirementsMet(true)
  })

  return (
    <div>
      <VideoPlayer provider={lessonQuery.data?.provider} provider_id={lessonQuery.data?.provider_id} />
    </div>
  )
}
